import { render, staticRenderFns } from "./assemble.vue?vue&type=template&id=56eacd00&"
import script from "./assemble.vue?vue&type=script&lang=js&"
export * from "./assemble.vue?vue&type=script&lang=js&"
import style0 from "./assemble.vue?vue&type=style&index=0&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports